export const UPDATE_CLAIM_IDO           = "UPDATE_CLAIM_IDO";
export const GET_SIGNATURE_CLAIM_IDO    = "GET_SIGNATURE_CLAIM_IDO";
export const GET_SIGNATURE_REFUND_IDO    = "GET_SIGNATURE_REFUND_IDO";
export const GET_ALLOCATION_COMMUNITY_BY_ADDRESS = "GET_ALLOCATION_COMMUNITY_BY_ADDRESS";
export const GET_ALLOCATION_GUARANTEED_BY_ADDRESS = "GET_ALLOCATION_GUARANTEED_BY_ADDRESS";
export const GET_ALLOCATION_PRIVATE_BY_ADDRESS = "GET_ALLOCATION_PRIVATE_BY_ADDRESS";
export const GET_ALLOCATION_BY_ADDRESS = "GET_ALLOCATION_BY_ADDRESS";
